// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  /* Evita que el zoom de accesibilidad de Android/iOS distorsione el layout */
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

html,
body {
  height: 100%;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow-x: hidden;
  -webkit-user-select: none;
  user-select: none;
}

@media (max-width: 600px) {
  html {
    font-size: 14px;
  }
}

.app {
  height: 100dvh; /* dvh en lugar de vh para móviles con barra dinámica */
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden; /* NO overflow: auto en el raíz para evitar doble scroll en native */
}

.header {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border-radius: 1rem;
  padding: 1rem;
  margin-bottom: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 60px;
}

@media (max-width: 600px) {
  .header {
    padding: 0.5rem;
    margin-bottom: 1rem;
    min-height: 48px;
    border-radius: 0.75rem;
  }
}

.title {
  font-size: clamp(1.2rem, 4vw, 1.8rem);
  font-weight: bold;
  color: #1a1a1a;
  text-align: center;
  flex: 1;
  margin: 0;
}

/* Page content containers */
.page-content {
  flex: 1;
  min-height: 0; /* necesario para que overflow-y: auto funcione en flex children */
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  padding: 1rem;
  padding-bottom: calc(1.5rem + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Las Cards de MUI tienen overflow:hidden por defecto, lo que hace que flexbox
   calcule su min-height automático como 0 y permita que se aprieten en vez de
   respetar su tamaño mínimo y activar el scroll de .page-content */
.page-content > * {
  flex-shrink: 0;
}

/* Allow text selection in input fields */
input,
textarea {
  -webkit-user-select: text;
  user-select: text;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4EAA4E;EAC5E,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,4DAA4D;EAC5D,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc,EAAE,uDAAuD;EACvE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB,EAAE,oEAAoE;AACxF;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,OAAO;EACP,aAAa,EAAE,kEAAkE;EACjF,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,+DAA+D;EAC/D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;mEAEmE;AACnE;EACE,cAAc;AAChB;;AAEA,yCAAyC;AACzC;;EAEE,yBAAyB;EACzB,iBAAiB;AACnB","sourcesContent":["* {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nhtml {\r\n  /* Evita que el zoom de accesibilidad de Android/iOS distorsione el layout */\r\n  -webkit-text-size-adjust: 100%;\r\n  text-size-adjust: 100%;\r\n}\r\n\r\nhtml,\r\nbody {\r\n  height: 100%;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  overflow-x: hidden;\r\n  -webkit-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  html {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n.app {\r\n  height: 100dvh; /* dvh en lugar de vh para móviles con barra dinámica */\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  overflow: hidden; /* NO overflow: auto en el raíz para evitar doble scroll en native */\r\n}\r\n\r\n.header {\r\n  background: rgba(255, 255, 255, 0.98);\r\n  backdrop-filter: blur(20px);\r\n  border-radius: 1rem;\r\n  padding: 1rem;\r\n  margin-bottom: 2rem;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  min-height: 60px;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .header {\r\n    padding: 0.5rem;\r\n    margin-bottom: 1rem;\r\n    min-height: 48px;\r\n    border-radius: 0.75rem;\r\n  }\r\n}\r\n\r\n.title {\r\n  font-size: clamp(1.2rem, 4vw, 1.8rem);\r\n  font-weight: bold;\r\n  color: #1a1a1a;\r\n  text-align: center;\r\n  flex: 1;\r\n  margin: 0;\r\n}\r\n\r\n/* Page content containers */\r\n.page-content {\r\n  flex: 1;\r\n  min-height: 0; /* necesario para que overflow-y: auto funcione en flex children */\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  -webkit-overflow-scrolling: touch;\r\n  touch-action: pan-y;\r\n  padding: 1rem;\r\n  padding-bottom: calc(1.5rem + env(safe-area-inset-bottom, 0px));\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n/* Las Cards de MUI tienen overflow:hidden por defecto, lo que hace que flexbox\r\n   calcule su min-height automático como 0 y permita que se aprieten en vez de\r\n   respetar su tamaño mínimo y activar el scroll de .page-content */\r\n.page-content > * {\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Allow text selection in input fields */\r\ninput,\r\ntextarea {\r\n  -webkit-user-select: text;\r\n  user-select: text;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
